function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 0.5C6.55587 0.5 0.5 6.05187 0.5 12.875C0.5 16.2534 1.994 19.3111 4.397 21.5465C4.67038 21.7996 4.83125 22.163 4.76713 22.5298C4.5455 23.8201 3.93912 25.1555 2.93112 26.5066L2.858 26.6056C2.79755 26.6897 2.76139 26.7888 2.75347 26.8921C2.74555 26.9953 2.76617 27.0988 2.81309 27.1911C2.86001 27.2834 2.93141 27.3611 3.01949 27.4156C3.10757 27.47 3.20894 27.4993 3.3125 27.5C6.16212 27.5 8.09488 26.4335 9.41338 25.0947C9.69463 24.8079 10.1131 24.7269 10.5035 24.8225C11.6195 25.0993 12.7895 25.25 14 25.25C21.4441 25.25 27.5 19.6981 27.5 12.875C27.5 6.05187 21.4441 0.5 14 0.5Z"
});

function SvgIcAreaMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAreaMessage);
export default ForwardRef;